module.exports = __webpack_public_path__ + "assets/img/A5-1.f6623fbd.jpg";